import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 19.06 20",
  "content": "<symbol viewBox=\"0 0 19.06 20\" id=\"list\"><title>list</title><rect x=\"4.53\" y=\"0.38\" width=\"14.49\" height=\"1.81\" rx=\"0.91\" ry=\"0.91\" /><path d=\"M.5,1.29A1.17,1.17,0,1,0,1.67.11,1.17,1.17,0,0,0,.5,1.29Z\" transform=\"translate(-0.47 0)\" /><rect x=\"4.53\" y=\"5.79\" width=\"14.49\" height=\"1.81\" rx=\"0.91\" ry=\"0.91\" /><path d=\"M.5,6.7A1.17,1.17,0,1,0,1.67,5.53,1.17,1.17,0,0,0,.5,6.7Z\" transform=\"translate(-0.47 0)\" /><rect x=\"4.53\" y=\"11.41\" width=\"14.49\" height=\"1.81\" rx=\"0.91\" ry=\"0.91\" /><path d=\"M.5,12.31a1.17,1.17,0,1,0,1.17-1.17A1.17,1.17,0,0,0,.5,12.31Z\" transform=\"translate(-0.47 0)\" /><rect x=\"4.53\" y=\"16.82\" width=\"14.49\" height=\"1.81\" rx=\"0.91\" ry=\"0.91\" /><path d=\"M.5,17.72a1.17,1.17,0,1,0,1.17-1.17A1.17,1.17,0,0,0,.5,17.72Z\" transform=\"translate(-0.47 0)\" /><rect width=\"19.06\" height=\"20\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/list.svg
// module id = lFS3
// module chunks = 264